import React, {useState, useEffect} from 'react';
import Aux from '../../hoc/Aux';
import Accordeon from './Accordeon';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import smartLogo from '../../BuildingSMART_CMYK_Germany_350.jpeg';
import helpVideoDE from '../../ps-help-video-de.png';
import helpVideoEN from '../../ps-help-video-en.png';
import { currentLang } from '../../store/actions/support';
import LogoDescription from './LogoDescription';

const help = (props) => {

  const location = useLocation()
  const initialOpenTab = (location !== undefined && location.openTab !== undefined)? location.openTab : 0;
  const [openTab, setOpenTab] = useState(initialOpenTab);
  const ht = useCustomHtmlTranslation();
  const { t } = useTranslation();
  const { hash } = useLocation();

  useEffect(() => {
      const initialTab = hash.substring(1);
      if (!isNaN(parseInt(initialTab, 10))) { setOpenTab(parseInt(initialTab, 10)); };
    }, []);


  const openAction = () => {
    return (x) => {
      if (openTab === x) {
        setOpenTab(0);
      } else {
        setOpenTab(x);
      }
    }
  }

  return (
    <Aux>
      <div className="main-container">
         <div className="container">
            <div className="row justify-content-center">
               <div className="col-lg-11 col-xl-10">
                  <div className="page-header">
                     <h1>{ t('help.headline') }</h1>
                     <p className="lead"></p>
                  </div>
                  <div className="tab-content-white">
                     <div className="tab-pane fade show active" id="tasks" role="tabpanel">
                        <div className="row content-list-head">
                           <div className="col" style={{width: "100%"}}>
                              <div className="paccordeon" id="accordionExample" style={{width: "100%"}}>

                                <Accordeon
                                  key="acc1"
                                  tabId={1}
                                  onClick={ openAction }
                                  checkOpen={ (x) => x === openTab }
                                  headline={ ht('content.help.to_be_advised.headline') }
                                  content= {
                                    <Aux>
                                      { ht('content.help.to_be_advised.part1') }
                                      { ht('content.help.to_be_advised.part2') }
                                    </Aux>
                                  }
                                />

                                <Accordeon
                                  key="acc2"
                                  tabId={2}
                                  onClick={ openAction }
                                  checkOpen={ (x) => x === openTab }
                                  headline={ ht('content.help.video_user_manual.headline') }
                                  content= {
                                    <Aux>
                                    { ht('content.help.video_user_manual.content') }
                                    <br />
                                    { (currentLang() === "de")?
                                      <a href={"https://vimeo.com/" + t('content.help.video_user_manual.vimeonumber')} rel="noopener noreferrer" target="_blank">
                                        <img width="750" src={helpVideoDE} alt="Hilfe-Video" />
                                      </a>
                                    :
                                      <a href={"https://vimeo.com/" + t('content.help.video_user_manual.vimeonumber')} rel="noopener noreferrer" target="_blank">
                                        <img width="750" src={helpVideoEN} alt="Hilfe-Video" />
                                      </a>
                                    }
                                    </Aux>
                                  }
                                />

                                <Accordeon
                                  key="acc3"
                                  tabId={3}
                                  onClick={ openAction }
                                  checkOpen={ (x) => x === openTab }
                                  headline={ ht('content.help.need_support.headline') }
                                  content= { ht('content.help.need_support') }
                                />

                                <Accordeon
                                  key="acc4"
                                  tabId={4}
                                  onClick={ openAction }
                                  checkOpen={ (x) => x === openTab }
                                  headline={ ht('content.help.available_product_systems.headline') }
                                  content= { ht('content.help.available_product_systems') }
                                />

                                <Accordeon
                                  key="acc5"
                                  tabId={5}
                                  onClick={ openAction }
                                  checkOpen={ (x) => x === openTab }
                                  headline={ ht('content.help.bim.headline') }
                                  content= {
                                    <Aux>
                                      { ht('content.help.bim') }
                                      <br />
                                      <a href="https://www.buildingsmart.de/buildingsmart/mitglieder/rudolf-hensel-gmbh" rel="noopener noreferrer" target="_blank">
                                        <img src={smartLogo} alt="buildingsmart-logo" />
                                      </a>
                                    </Aux>
                                  }
                                />

                                <Accordeon
                                  key="acc6"
                                  tabId={6}
                                  onClick={ openAction }
                                  checkOpen={ (x) => x === openTab }
                                  headline={ ht('content.help.version_history.headline') }
                                  content= {
                                    <div className="history">
                                      { ht('content.help.version_history') }
                                    </div>
                                  }
                                />

                                <Accordeon
                                  key="acc7"
                                  tabId={7}
                                  onClick={ openAction }
                                  checkOpen={ (x) => x === openTab }
                                  headline={ ht('content.help.seals.headline') }
                                  content= {
                                    <div className="history">
                                      <LogoDescription />
                                    </div>
                                  }
                                />


                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      </div>
    </Aux>
  )
};

export default help;



// WEBPACK FOOTER //
// ./src/components/Home/Help.js